import React, { useEffect } from "react";
import { jsPDF } from "jspdf";
import html2canvas from "html2canvas";
import { DocumentScanner } from "@mui/icons-material";
import { useRef } from "react";
import "jspdf-autotable";
import { formatSignatureDate } from "../../../utils/formatSignatureDate";
import { lfuk48OptText } from "./content";
import moment from "moment";
import { imageToBase64 } from "../../../utils/imageToBase64";
import { uploadCRMDocumentAndGetUrl } from "../../../utils/uploadDocument";
import { post } from "../../../api";

export const generatePDF = async (data, user, sasToken, isSendToTalentTrail = false, token, candidateId) => {
  const doc = new jsPDF();
  doc.setFont("helvetica", "bold");
  doc.setFontSize(16);
  doc.text(
    "Rapid Resourcing - 48hr Opt Out Form",
    105,
    30,
    { align: "center" }
  );

  doc.setFont("helvetica", "bold");
  doc.setFontSize(14);
  doc.text("Personal Information", 105, 50, { align: "center" });

  // Set fonts and alignments on the second page
  doc.setFont("helvetica", "norboldmal");
  doc.setFontSize(12);
  doc.text("Title", 10, 80);
  // Set fonts and alignments on the second page
  doc.setFont("helvetica", "normal");
  doc.setFontSize(10);
  doc.text(`${data?.title}`, 10, 85);

  // Set fonts and alignments on the second page
  doc.setFont("helvetica", "norboldmal");
  doc.setFontSize(12);
  doc.text("First Name", 10, 95);
  // Set fonts and alignments on the second page
  doc.setFont("helvetica", "normal");
  doc.setFontSize(10);
  doc.text(`${data?.firstName}`, 10, 100);

  // Set fonts and alignments on the second page
  doc.setFont("helvetica", "norboldmal");
  doc.setFontSize(12);
  doc.text("Surname", 10, 110);
  // Set fonts and alignments on the second page
  doc.setFont("helvetica", "normal");
  doc.setFontSize(10);
  doc.text(`${data?.surName}`, 10, 115);

  // Set fonts and alignments on the second page
  doc.setFont("helvetica", "norboldmal");
  doc.setFontSize(12);
  doc.text("Home Address", 10, 125);
  // Set fonts and alignments on the second page
  doc.setFont("helvetica", "normal");
  doc.setFontSize(10);
  doc.text(`${data?.homeAddress}`, 10, 130);

  // Set fonts and alignments on the second page
  doc.setFont("helvetica", "norboldmal");
  doc.setFontSize(12);
  doc.text("Postcode", 10, 140);
  // Set fonts and alignments on the second page
  doc.setFont("helvetica", "normal");
  doc.setFontSize(10);
  doc.text(`${data?.postCode}`, 10, 145);

  // Set fonts and alignments on the second page
  doc.setFont("helvetica", "norboldmal");
  doc.setFontSize(12);
  doc.text("Mobile Number", 10, 155);
  // Set fonts and alignments on the second page
  doc.setFont("helvetica", "normal");
  doc.setFontSize(10);
  doc.text(`${data?.mobile}`, 10, 160);

  // Set fonts and alignments on the second page
  doc.setFont("helvetica", "norboldmal");
  doc.setFontSize(12);
  doc.text("Landline Number", 10, 170);
  // Set fonts and alignments on the second page
  doc.setFont("helvetica", "normal");
  doc.setFontSize(10);
  doc.text(`${data?.landlineNumber || '--'}`, 10, 175);

  // Set fonts and alignments on the second page
  doc.setFont("helvetica", "norboldmal");
  doc.setFontSize(12);
  doc.text("Email Address", 10, 185);
  // Set fonts and alignments on the second page
  doc.setFont("helvetica", "normal");
  doc.setFontSize(10);
  doc.text(`${data?.email}`, 10, 190);

  // Table Data
  doc.addPage();

  const pageHeight = doc.internal.pageSize.height;
  const pageWidth = doc.internal.pageSize.width;
  const margin = 10;
  const maxLineHeight = 5; // Adjust this value based on the font size

  const lines = doc.splitTextToSize(lfuk48OptText, pageWidth - margin * 2);
  doc.setFontSize(10);
  let currentHeight = margin;
  lines.forEach((line) => {
    if (currentHeight + maxLineHeight > pageHeight - margin) {
      doc.addPage(); // Add a new page when the text exceeds the page height
      currentHeight = margin; // Reset the height for the new page
    }
    doc.text(line, margin, currentHeight);
    currentHeight += maxLineHeight; // Move to the next line
  });
  currentHeight += 10;
  doc.setFont("helvetica", "bold");
  doc.setFontSize(10);
  doc.text(
    `Applicant Name(Print): ${data?.firstName} ${data?.surName}`,
    10,
    currentHeight
  );
  currentHeight += 5;
  doc.setFont("helvetica", "normal");
  doc.setFontSize(10);
  doc.text(`${data.signedDate}`, 10, currentHeight);

  currentHeight += 5;
  doc.setFont("helvetica", "bold");
  doc.setFontSize(10);
  doc.text(`Signed`, 10, currentHeight);
  // Add the signature image if the URL exists
  if (data?.signature) {
    try {
      const imgData = await imageToBase64(`${data.signature}?${sasToken}`);
      doc.addImage(imgData, "JPEG", 25, currentHeight, 30, 15);
    } catch (e) {
      console.error("Error loading signature image:", e);
    }
  }

  doc.addPage();
  currentHeight = 20;

  // Set bold text on the left
  doc.setFont("helvetica", "bold");
  doc.setFontSize(12);
  doc.text("Signable Form Title", margin, currentHeight); // Add bold text on the left
  doc.setFont("helvetica", "normal");
  doc.text("Rapid Resourcing - 48hr Opt Out Form", pageWidth * 0.4, currentHeight); // Add the normal text 30% from the left

  currentHeight += 10;

  doc.setFont("helvetica", "bold");
  doc.setFontSize(12);
  doc.text("Signable Form Provided by", margin, currentHeight); // Add bold text on the left
  doc.setFont("helvetica", "normal");
  doc.text("Rapid Resourcing", pageWidth * 0.4, currentHeight); // Add the normal text 30% from the left
  currentHeight += 10;

  doc.line(margin, currentHeight, pageWidth - margin, currentHeight); // Draw a horizontal line across the page
  currentHeight += 10; // Move down a little to make space for the paragraph
  // Add paragraph text after the line
  const paragraphText = `By signing this page, I confirm that I fully understand the content and agree to adhere to it at all times. I also agree that all the details provided in this document are accurate and complete to the best of my knowledge.`;

  // Use splitTextToSize to fit the paragraph within the page width
  const paragraphLines = doc.splitTextToSize(
    paragraphText,
    pageWidth - 2 * margin
  );

  // Add the paragraph to the document
  doc.setFontSize(10);
  doc.text(paragraphLines, margin, currentHeight); // Render paragraph
  currentHeight += 20;

  // Add paragraph text after the line
  const paragraphText2 = `By ticking this box I consent to the company processing my data and the evidence of this document being stored within their system for the purpose of work finding services.`;

  // Use splitTextToSize to fit the paragraph within the page width
  const paragraphLines2 = doc.splitTextToSize(
    paragraphText2,
    pageWidth - 2 * margin
  );

  // Add the paragraph to the document
  doc.text(paragraphLines2, margin, currentHeight); // Render paragraph
  currentHeight += 40;

  doc.setFont("helvetica", "bold");
  doc.setFontSize(12);
  doc.text("Date Signed", margin, currentHeight); // Add bold text on the left
  doc.setFont("helvetica", "normal");
  doc.text(`${data?.signDate ? moment(data?.signDate).format("DD-MM-YYYY") : '--'}`, pageWidth * 0.4, currentHeight); // Add the normal text 30% from the left
  currentHeight += 10;

  // Add signature image from URL
  doc.setFont("helvetica", "bold");
  doc.setFontSize(12);
  doc.text("Signature", margin, currentHeight);

  // Add the signature image if the URL exists
  if (data?.signature) {
    try {
      const imgData = await imageToBase64(`${data.signature}?${sasToken}`);
      doc.addImage(imgData, "JPEG", pageWidth * 0.4, currentHeight, 30, 15);
    } catch (e) {
      console.error("Error loading signature image:", e);
    }
  }
  currentHeight += 20;

  doc.setFont("helvetica", "bold");
  doc.setFontSize(12);
  doc.text("Name", margin, currentHeight); // Add bold text on the left
  doc.setFont("helvetica", "normal");
  doc.text(
    `${user?.firstName} ${user?.lastName}`,
    pageWidth * 0.4,
    currentHeight
  ); // Add the normal text 30% from the left
  currentHeight += 10;

  doc.setFont("helvetica", "bold");
  doc.setFontSize(12);
  doc.text("IP Address", margin, currentHeight); // Add bold text on the left
  doc.setFont("helvetica", "normal");
  doc.text(`${data?.ipAddress}`, pageWidth * 0.4, currentHeight); // Add the normal text 30% from the left
  currentHeight += 10;

  // Save the PDF
  if (isSendToTalentTrail) {
    const pdfBlob = doc.output("blob");
    const formData = new FormData();
    formData.append(
      "file",
      pdfBlob,
      `rapid-resourcing-48hr-opt-out-form-${user.firstName}-${user.lastName}.pdf`
    );
    formData.append("candidateId", candidateId);
    const documentUrl =
      (await uploadCRMDocumentAndGetUrl(formData, token)) || "";
    console.log("documentUrl", documentUrl);
    if (documentUrl) {
      const payload = {
        candidateId,
        fileName: `rapid-resourcing-48hr-opt-out-form-${user.firstName}-${user.lastName}.pdf`,
        fileExtention: ".pdf",
        fileType: "workExperience",
        fileLink: documentUrl,
        licenseNo: "rapidresourcing",
      };

      const url = "/api/candidate/save-document";
      try {
        const res2 = await post(url, payload);
        console.log("Document saved successfully:", res2.data);
      } catch (error) {
        console.error("Error saving document:", error);
      }
    } else {
      console.error("Failed to upload document, skipping save.");
    }
  } else {
    doc.save(`rapid-resourcing-48hr-opt-out-form-${user.firstName}-${user.lastName}.pdf`);
  }
};
const Lfuk48hrOptOutFormDownload = ({ data, sasToken, user }) => {
  const signatureRef = useRef(null); // Create a reference to the image element
  useEffect(() => {
    if (signatureRef.current) {
      // Set the crossOrigin attribute to allow cross-origin image loading
      signatureRef.current.crossOrigin = 'anonymous';
    }
  }, []);
 
  return (
    <>
      <div className="text-center p-4 document-sign">
        <p>{formatSignatureDate(data?.signDate, user)}</p>
        <div>
          {data?.signature && (
            <img ref={signatureRef} src={`${data?.signature}?${sasToken}`} />
          )}
        </div>
      </div>
      <div className="text-center w-100 mt-4">
        <button className="btn btn-success btn-lg" onClick={() => generatePDF(data, user, sasToken)}>
          <DocumentScanner /> Download your receipt
        </button>
      </div>
    </>
  );
};

export default Lfuk48hrOptOutFormDownload;
